export default "__VITE_ASSET__mvbJ0mNI__"